exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-tools[data-v-438dfbb6]{\n  text-align: right;\n}\n.modify_box[data-v-438dfbb6]{\n  width: 52px;\n  margin-bottom: 10px;\n}\n.doc_description[data-v-438dfbb6]{\n  max-width: 350px;\n  padding: 0;\n  margin-bottom: 0;\n  font-family: inherit;\n  font-size: inherit;\n}\n.masa_berlaku[data-v-438dfbb6]{\n  min-width: 110px;\n}\n", ""]);

// exports
